import { createSlice } from "@reduxjs/toolkit";

export const commonSlice = createSlice({
  name: "common",
  initialState: {
    company: 0,
    currentItemMenuId: 0,
    openedMenuItems: [],
  },
  reducers: {
    setCompany: (state, action) => {
      state.company = action.payload;
    },
    setWithStealthFlow: (state, action) => {
      state.withStealthFlow = action.payload;
    },
    setCurrentItemMenuId: (state, action) => {
      state.currentItemMenuId = action.payload;
    },
    setOpenedMenuItems: (state, action) => {
      let items = state.openedMenuItems;
      if(action.payload.open){
        items.push(action.payload.id);
      }
      else{
        const index = items.indexOf(action.payload.id);
        if (index > -1) { 
          items.splice(index, 1); 
        }
      }
      state.openedMenuItems = items;
    }
  },
});

// Action creators are generated for each case reducer function
export const { setCompany, setWithStealthFlow, setCurrentItemMenuId, setOpenedMenuItems } = commonSlice.actions;

export default commonSlice.reducer;
